import { apiConfig } from "@/helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const userService = {
    login,
    logout,
    getCurrentUserPermissions,    
    GetUsersWithRoles,
    getAll,
    getById,
    update,
    create,
    delete: _delete,
    resetPassword,
    checkIfCompanyAvailable,
    changePassword,
    enable2FA,
    verifyTwoFactorCode,
    verifyTwoFactorLogin,
    reset2FA,
};

function login(username, password,tenantId) {
    
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Abp-TenantId': tenantId },
        body: JSON.stringify({ "userNameOrEmailAddress": username, "password": password, "rememberClient": true }),
        credentials: 'include'
    };
    
    if(tenantId == 0)
        delete requestOptions.headers['Abp-TenantId']

    return fetch(`${apiConfig.apiUrl}/api/TokenAuth/Authenticate`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            
            if (user.result.accessToken) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes                
                localStorage.setItem('user', JSON.stringify(user.result));
            }

            return user.result;
        });
}

function getCurrentUserPermissions() {
    var user = localStorage.getItem('user');

    if(user !== null)
    {
        const requestOptions = {
            method: 'GET',
            headers: authHeader()
        };
        return fetch(`${apiConfig.apiUrl}/api/services/app/Session/GetCurrentLoginInformations`, requestOptions).then(handleResponse).then(result => {
            if(result.result.user == null)
            {
                logout();
                location.reload(true);
            }
            if(result.result)
                return result.result;
            else
                return null;
        });
    }
    return new Promise().reject();
}
function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

/*function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(`${config.apiUrl}/users/register`, requestOptions).then(handleResponse);
}*/

function getAll(data) {    
    return axios.get('/api/services/app/User/GetAll', {
        params: {
            Keyword: data.query,
            SkipCount: (data.page-1) * data.limit,
            MaxResultCount: data.limit,
            Sorting: data.sorting,
            isActive: data.isActive
        },
        baseURL: apiConfig.apiUrl,
        headers: authHeader()        
    })
}
function GetUsersWithRoles(data)
{
    return axios.post('/api/services/app/User/QueryUsersWithRoles', data,{
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}

function getById(id) {
    return axios.get('/api/services/app/User/Get', {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            Id: id
        }
    })         
}
function checkIfCompanyAvailable(companyName)
{
    
    return axios.post('/api/services/app/Account/IsTenantAvailable',{tenancyName: companyName}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })       
}
function update(data) {
    return axios.put('/api/services/app/User/Update',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })    
}
function resetPassword(data) {
    return axios.post('/api/services/app/User/ResetPassword',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })
}
// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(`${apiConfig.apiUrl}/users/${id}`, requestOptions).then(handleResponse);
}
function create(data)
{
    return axios.post('/api/services/app/User/Create',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })
}
function handleResponse(response) {
    return response.text().then(text => {
        
        
        const data = text && JSON.parse(text);
            
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }


            const error = ( (data.error && data.error.message + ( ' '+data.error.details) ) ||(data && data.message)   ) || response.statusText;            
            return Promise.reject(error);
        }
        
        return data;
    });
}
function changePassword(data) {
    return axios.post('/api/services/app/User/ChangePassword',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function enable2FA()
{
    return axios.post('/api/TokenAuth/EnableTwoFactorAuthentication',null, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}

function verifyTwoFactorCode(data)
{
    return axios.post('/api/TokenAuth/VerifyTwoFactorCode',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function verifyTwoFactorLogin(code,token,tenantId)
{

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Abp-TenantId': tenantId },
        body: JSON.stringify({ "code": code, "twoFactorToken": token }),
        credentials: 'include'
    };
    if(tenantId == 0)
        delete requestOptions.headers['Abp-TenantId']

    return fetch(`${apiConfig.apiUrl}/api/TokenAuth/VerifyTwoFactorLogin`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response

            if (user.result.accessToken) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user.result));
            }

            return user.result;
        });
}
function reset2FA(userid)
{
    return axios.post('/api/services/app/User/Reset2FA', {id:userid}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}